import axios from 'axios';
import ApiClient from './ApiClient';

class WhatsappCommonGroupsAPI extends ApiClient {
  constructor() {
    super('whatsapp_qr', { accountScoped: true });
  }

  get(conversationId) {
    return axios.get(
      `${this.url}/conversations/${conversationId}/common_groups`
    );
  }
}

export default new WhatsappCommonGroupsAPI();
